import actions from './actions'

const initState = {
    lang: 'vi',
    listLangs: [
        {
            code: 'vi',
            id: 'topbar.language.vi'
        },
        {
            code: 'en',
            id: 'topbar.language.en'
        }
    ]
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.CHANGE_LANGUAGE:
            return {
                ...state,
                ...{
                    lang: action.payload.language,
                },
            }

        default:
            return state
    }
}

export default reducer
